import styled from 'styled-components';
import { Modal as ModalBase } from 'components';

export const Modal = styled(ModalBase).attrs({
  bodyStyle: { padding: 0, overflow: 'hidden' },
})``;
